import { CustomTableColumn } from "./custom-table-column";

export class SimpleTableColumn extends CustomTableColumn {
    constructor(name: string, label: string, path: string) {
        super(name, label, path);
    }
}
